import { render } from "./CommercialSidebar.vue?vue&type=template&id=89e3bf82&ts=true"
import script from "./CommercialSidebar.vue?vue&type=script&lang=ts"
export * from "./CommercialSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__